import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ApplicationState } from 'store';
import { AcademyState } from 'store/modules/academy_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import { setFloatingState } from 'store/modules/academy_store/actions';
import { setFloatingPref } from 'services/academy_floating';
import AcademyPlayer from 'components/atoms/academy_player';
import { Container } from './styles';

const AcademyFloatingVideo: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = useLocation();
  const { liveNow, floatingState } = useSelector<ApplicationState, AcademyState>(
    (s) => s.session.academy,
  );
  const { profile } = useSelector<ApplicationState, ProfileState>((s) => s.storage.profile);

  const minimize = () => {
    if (!liveNow) return;
    setFloatingPref(liveNow.id, 'minimized');
    dispatch(setFloatingState('minimized'));
  };

  // Não mostra na própria aba AO VIVO (nem no /academy sem aba, que já abre no AO VIVO).
  const onLivePage = pathname === '/academy' || pathname.startsWith('/academy/ao-vivo');

  if (
    !profile?.isSigned ||
    !liveNow ||
    !liveNow.embed_url ||
    floatingState !== 'expanded' ||
    onLivePage
  ) {
    return null;
  }

  return (
    <Container>
      <div className="floating-header">
        <span className="title">
          <span className="live-dot" />
          Ao vivo agora
        </span>
        <span className="actions">
          <button
            type="button"
            aria-label="Expandir"
            title="Assistir em tela cheia"
            onClick={() => history.push('/academy/ao-vivo')}
          >
            <i className="material-icons">open_in_full</i>
          </button>
          <button type="button" aria-label="Fechar" title="Fechar" onClick={minimize}>
            <i className="material-icons">close</i>
          </button>
        </span>
      </div>
      <AcademyPlayer src={liveNow.embed_url} title={liveNow.title} autoplay muted />
      <div className="floating-title">{liveNow.title}</div>
    </Container>
  );
};

export default AcademyFloatingVideo;
